import { render, staticRenderFns } from "./InquiryFormEn.vue?vue&type=template&id=7f061f59"
import script from "./InquiryFormEn.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryFormEn.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports